import { createPortal } from "react-dom";

import Backdrop from "@/components/Backdrop";
import ScrollLock from "@/components/ScrollLock";
import { MODAL_ROOT_ID } from "@/constants";
import useEscape from "@/hooks/useEscape";

const ROOT =
  typeof window !== "undefined" ? document.getElementById(MODAL_ROOT_ID) : null;

export interface DialogProps {
  open: boolean;
  noPortal?: boolean;
  noBackdrop?: boolean;
  onClose?: () => void;
  children?: React.ReactNode;
}

/**
 * Renders something on top of the site along with an optional backdrop and a scroll-lock
 * Does not handle z-index.
 */
const Dialog: React.FunctionComponent<DialogProps> = ({
  children,
  onClose,
  noBackdrop = false,
  open,
  noPortal,
}) => {
  // render the item straight into the current DomPosition

  useEscape(() => onClose && onClose());

  const content = (
    <>
      {!noBackdrop && <Backdrop open={open} onClick={onClose} />}
      {open && <ScrollLock />}
      {children}
    </>
  );

  if (noPortal) {
    return content;
  }

  // Render in using a portal in a separate react tree.
  if (ROOT) {
    return createPortal(content, ROOT);
  }
  return null;
};
export default Dialog;
